export default __webpack_public_path__ + "static/media/2128.6e3d5306.png";